import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

const AddDeviceComponent = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

// Define schemas using Zod
const ZCreateEmailGroupResponse = z.object({
  id: z.string(),
  groupName: z.string(),
  tenantId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  modifiedBy: z.string(),
  enabled: z.boolean()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZCreateEmailGroupResponse,
  error_message: z.optional(z.string())
})

// Export types derived from Zod schemas
export type CreateEmailGroupResponse = z.infer<typeof ZCreateEmailGroupResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export interface CreateEmailGroupRequest {
  groupName: string
  siteIds: string[]
  severityIds: string
  distributionList: string
  enabled: boolean
}

export async function createEmailGroup (
  createRequest: CreateEmailGroupRequest,
  onSuccess: (response: CreateEmailGroupResponse, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = '/communications-service/api/v1/udp/tiq/services/email/create-group'
  interceptedAxios
    .post(url, createRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure(AddDeviceComponent.NetworkError, error.status)
      }
    })
}
